module.exports = __webpack_public_path__ + "img/ER.804cbebd.svg";